import {useSafeEffect} from '@freckle/react-hooks'
import StorageHelper from '@freckle/educator-entities/ts/common/helpers/storage-helper'
import {isChromelessPath} from './is-chromeless-path'

const CHROMELESS_ACCESS_STORAGE_KEY = 'accessed-chromeless'

// Track whether any chromeless pages have ever been accessed in this session
export const useTrackChromelessAccess = () =>
  useSafeEffect(() => {
    if (isChromelessPath()) {
      StorageHelper.setSessionStorageProperty(CHROMELESS_ACCESS_STORAGE_KEY, true)
    }
  }, [])

// Has the user accessed chromeless pages this session?
export const useAccessedChromeless = (): boolean =>
  StorageHelper.getSessionStoragePropertyDefault<boolean>(CHROMELESS_ACCESS_STORAGE_KEY, false)
